import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "../../store/store"
import { searchOrder } from "../../network/actions";

export enum LoadingStatus{
    Loaded, Loading,Eror
}
export interface QrScan{

}
export interface QrScanState {
    status: LoadingStatus;
    data: any;
    focusInputKey: string;
    orderId: string;
    accessCode: string;
}
const initialState: QrScanState={
    status:LoadingStatus.Loaded,
    data :{

    },
    focusInputKey: '',
    orderId: '',
    accessCode: ''
}
export const qrScanSlice = createSlice({
    name: 'qrScan',
    initialState,
    reducers: {
        onKey: (state, action) => {
            switch (state.focusInputKey) {
                case 'orderId':
                    if (state.orderId.length < 10 && !isNaN(action.payload)) {
                        state.orderId += action.payload;
                    }
                    break;
                case 'accessCode':
                    if (state.accessCode.length < 6 && !isNaN(action.payload)) {
                        state.accessCode += action.payload;
                    }
                    break;
                default:
                    break;
            }
        },
        onBackspace: (state) => {
            switch (state.focusInputKey) {
                case 'orderId':
                    state.orderId = state.orderId.slice(0, -1);
                    break;
                case 'accessCode':
                    state.accessCode = state.accessCode.slice(0, -1);
                    break;
                default:
                    break;
            }
        },
        onChangeFocus: (state, action) => {
            state.focusInputKey = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(searchOrder.fulfilled, (state, action) => {
           
        })
        builder.addCase(searchOrder.pending, (state, action) => {
            state.status = LoadingStatus.Loading;
        })
        builder.addCase(searchOrder.rejected, (state, action) => {
          
        })

    }
  })
  
  export const { onKey, onBackspace, onChangeFocus } = qrScanSlice.actions
  
  // Other code such as selectors can use the imported `RootState` type
  export const selectQrScanState = (state: RootState) => state.qrScan
  export const selectLoadingStatusState = (state: RootState) => state.qrScan
  
  export default qrScanSlice.reducer
